import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Modal, Form, Button, message } from 'antd';
import { ChangePasswordForm } from './ChangePasswordForm';
import { useChangePasswordUser } from '@/hooks/useChangePasswordUser';

interface ModalFormProps {
	visible?: boolean;
	onClose: () => void;
}

interface FormData {
	password: string;
	current_password: string;
}

const { useForm } = Form;

export function ModalForm({ visible = false, onClose }: Readonly<ModalFormProps>) {
	const [form] = useForm<FormData>();
	const { isLoading, mutateAsync: changePassword } = useChangePasswordUser();

	function handleOnClose() {
		onClose();
		form.resetFields();
	}

	async function handleOnSubmit(): Promise<void> {
		const { password, current_password } = await form.validateFields();
		const parameters = { current_password, password };
		changePassword(parameters, {
			onSuccess: (data) => {
				message.success(I18n.get(data.message));
				handleOnClose();
			},
			onError: (error: any) => {
				const exception = error.response?.data || error;
				const msg = exception.details[0] || exception.message;
				message.error(I18n.get(msg));
			}
		});
	}

	return (
		<Modal
			open={visible}
			onCancel={handleOnClose}
			footer={[
				<Button key="cancel" onClick={handleOnClose}>
					{I18n.get('Cancel')}
				</Button>,
				<Button key="save" type="primary" loading={isLoading} onClick={handleOnSubmit}>
					{I18n.get('Save')}
				</Button>
			]}
		>
			<ChangePasswordForm form={form} />
		</Modal>
	);
}
